import { Button, Typography } from '@mui/material'
import { CancelOutlined } from '@mui/icons-material'

import AccessGateLayout from './AccessGateLayout'

interface AccessGateRejectedProps {
  entityName: string
  message?: string
  onTryAnotherCode: () => void
}

const AccessGateRejected: React.FC<AccessGateRejectedProps> = ({ entityName, message, onTryAnotherCode }) => {
  return (
    <AccessGateLayout>
      <CancelOutlined color="error" sx={{ fontSize: 72 }} />

      <Typography variant="h6" fontWeight={700}>
        Solicitação recusada
      </Typography>
      <Typography variant="body2" color="text.secondary">
        {message || `O gestor de ${entityName} recusou sua solicitação de acesso.`}
      </Typography>
      <Typography variant="body2" color="text.secondary">
        Procure o administrador ou síndico de <strong>{entityName}</strong> para entender o motivo, ou tente outro
        código de acesso.
      </Typography>

      <Button variant="contained" onClick={onTryAnotherCode} sx={{ borderRadius: 20 }}>
        Tentar outro código
      </Button>
    </AccessGateLayout>
  )
}

export default AccessGateRejected
